import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PinnedSubheaderList from './PinnedSubheaderList';
import ClientProvider from './client';
export default createDemo(import.meta.url, PinnedSubheaderList, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/lists/demos/pinned-subheader/PinnedSubheaderList.tsx",
    "fileName": "PinnedSubheaderList.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListSubheader from '@mui/material/ListSubheader';\n\nexport default function PinnedSubheaderList() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <List\n      sx={{\n        width: '100%',\n        maxWidth: 360,\n        bgcolor: 'background.paper',\n        position: 'relative',\n        overflow: 'auto',\n        maxHeight: 300,\n        '& ul': { padding: 0 },\n      }}\n      subheader={<li />}\n    >\n      {[0, 1, 2, 3, 4].map((sectionId) => (\n        <li key={`section-${sectionId}`}>\n          <ul>\n            <ListSubheader>{`I'm sticky ${sectionId}`}</ListSubheader>\n            {[0, 1, 2].map((item) => (\n              <ListItem key={`item-${sectionId}-${item}`}>\n                <ListItemText primary={`Item ${item}`} />\n              </ListItem>\n            ))}\n          </ul>\n        </li>\n      ))}\n    </List>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 34,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListSubheader from '@mui/material/ListSubheader';\n\nexport default function PinnedSubheaderList() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <List\n      sx={{\n        width: '100%',\n        maxWidth: 360,\n        bgcolor: 'background.paper',\n        position: 'relative',\n        overflow: 'auto',\n        maxHeight: 300,\n        '& ul': { padding: 0 },\n      }}\n      subheader={<li />}\n    >\n      {[0, 1, 2, 3, 4].map((sectionId) => (\n        <li key={`section-${sectionId}`}>\n          <ul>\n            <ListSubheader>{`I'm sticky ${sectionId}`}</ListSubheader>\n            {[0, 1, 2].map((item) => (\n              <ListItem key={`item-${sectionId}-${item}`}>\n                <ListItemText primary={`Item ${item}`} />\n              </ListItem>\n            ))}\n          </ul>\n        </li>\n      ))}\n    </List>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 34,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemText",
      "@mui/material/ListSubheader"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
